import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import Td from './Td';
import Tr from './Tr';
const Info = styled.p `
  margin: 0;
  color: ${({ theme }) => theme.colors.grey70_1};
  text-align: center;
`;
const TableInfo = ({ children, dataTestId }) => (_jsx("tbody", { children: _jsx(Tr, { children: _jsx(Td, { type: 'sub', padding: '14px', bgColor: 'transparent', children: _jsx(Info, { "data-testid": dataTestId, children: children }) }) }) }));
export default TableInfo;
